import { Component, Inject } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { ConfigStorage, UserStorage } from "@scisys-uim/uim-common";
import { FirearmAssignablePersonService, FirearmStorageLocationService, RangerFirearmAssignmentLogService, RangerService } from "assets-service";
import { RangerReturnFirearmsToStorageDialogComponent, RangerReturnFirearmsToStorageDialogConfigData, RangerReturnFirearmsToStorageDialogData } from "./ranger-return-firearms-to-storage-dialog.component";



export interface RangerLeavingDialogData extends RangerReturnFirearmsToStorageDialogData {
}

export interface RangerLeavingDialogConfigData extends RangerReturnFirearmsToStorageDialogConfigData {
}

@Component({
  selector: 'app-ranger-leaving-dialog',
  templateUrl: './ranger-leaving-dialog.component.html',
  styleUrls: ['./ranger-leaving-dialog.component.scss']
})
export class RangerLeavingDialogComponent extends RangerReturnFirearmsToStorageDialogComponent {

  constructor(
    dialogRef: MatDialogRef<RangerLeavingDialogComponent, RangerLeavingDialogData>,
    @Inject(MAT_DIALOG_DATA) data: RangerLeavingDialogConfigData,
    fb: FormBuilder,
    dialog: MatDialog,
    rangerService: RangerService,
    rangerFirearmAssignmentLogService: RangerFirearmAssignmentLogService,
    firearmAssignablePersonService: FirearmAssignablePersonService,
    firearmStorageLocationService: FirearmStorageLocationService,
    configService: ConfigStorage,
    userStorage: UserStorage) {
    super(dialogRef, data, fb, dialog, rangerService, rangerFirearmAssignmentLogService, firearmAssignablePersonService, firearmStorageLocationService, configService, userStorage);
  }

  isRangerLeavingEnabled() {
    return !this.hasPendingActions && !this.form.invalid;
  }

  rangerLeaving() {
    this.rangerService.rangerLeaving({
      rangerId: this.data.ranger?.rangerId,
      storageAssignee: {
        personId: this.item?.storageAssignee?.personId,
        username: this.item?.storageAssignee?.user?.user
      },
      locationId: this.item?.location?.firearmStorageLocationId,
      comments: this.item?.comments
    }).subscribe(result => {
      this.item.ranger = result;
      this.dialogRef.close(this.item);
    });
  }

}